<script setup>
import { computed, defineAsyncComponent } from 'vue';
import isMobile from 'is-mobile';

const Mobile = defineAsyncComponent(() => import('./m/index.vue'));
const Pc = defineAsyncComponent(() => import('./pc/index.vue'));

const currentComponent = computed(() => {
  return isMobile() ? Mobile : Pc;
});
</script>

<template>
  <component :is="currentComponent" />
</template>
